// Module
var code = "<div class=\"vui-side-form-container vui-side-form-container__hide\">\n    <div class=\"vui-side-form\" ng-transclude></div>\n</div>\n";
// Exports
module.exports = code;